function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Text } from "../utils";
export var useRouteParams = function() {
    for(var _len = arguments.length, paramNames = new Array(_len), _key = 0; _key < _len; _key++){
        paramNames[_key] = arguments[_key];
    }
    var params = useParams();
    if (paramNames.length === 1) {
        var _params_paramNames_;
        var _params_paramNames__split_;
        return _define_property({}, paramNames[0], (_params_paramNames__split_ = (_params_paramNames_ = params[paramNames[0]]) === null || _params_paramNames_ === void 0 ? void 0 : _params_paramNames_.split("_")[0]) !== null && _params_paramNames__split_ !== void 0 ? _params_paramNames__split_ : "");
    }
    return paramNames.reduce(function(acc, paramName) {
        var _params_paramName;
        var _params_paramName_split_;
        acc[paramName] = (_params_paramName_split_ = (_params_paramName = params[paramName]) === null || _params_paramName === void 0 ? void 0 : _params_paramName.split("_")[0]) !== null && _params_paramName_split_ !== void 0 ? _params_paramName_split_ : "";
        return acc;
    }, {});
};
var regEx = /\/:[a-zA-Z0-9-]+/;
export var namedRoute = function(route, params) {
    var args = Array.isArray(params) ? params : [
        params
    ];
    while(regEx.test(route)){
        var _args_;
        if (!(args === null || args === void 0 ? void 0 : (_args_ = args[0]) === null || _args_ === void 0 ? void 0 : _args_.id)) {
            throw new Error("Missing id param");
        }
        var _args__name;
        var appendix = "/" + [
            args[0].id,
            Text.toKebabCase((_args__name = args[0].name) !== null && _args__name !== void 0 ? _args__name : "")
        ].filter(Boolean).join("_");
        route = route.replace(regEx, appendix);
        args = args.slice(1);
    }
    return route;
};
export var useNavigateTo = function() {
    var navigate = useNavigate();
    var navigateTo = useCallback(function(route, params) {
        if (regEx.test(route)) {
            navigate(namedRoute(route, params));
        } else {
            navigate(route);
        }
    }, [
        navigate
    ]);
    return navigateTo;
};

//# sourceMappingURL=useRouteParams.js.map